module.exports = __webpack_public_path__ + "img/shenli.6ffc18eb.png";